import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Button, Modal, Paragraph, Popover, QuillText } from '@treams/treams-ui';

import CompetencyLevelsInput from '../../../../kakapo-ui-application/common/containers/CompetencyInput';

export default function GoalCreateCompetencyModal(props: {
	competency: graphql.Competency;
	onCancel: () => void;
	onSave: () => void;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const description = localize(props.competency.description ?? [])?.text;

	return (
		<Popover visible center>
			<Modal>
				<Modal.Header
					onClose={() => props.onCancel()}
					title={`${t('goals.create.form.competency.modal.title')}: ${localize(props.competency.title).text}`}
				/>
				<Modal.Contents>
					<Paragraph>{t('goals.create.form.competency.modal.instruction')}</Paragraph>
					<Box mt={2}>
						<QuillText value={description} />
					</Box>
					<Box mt={4}>
						<CompetencyLevelsInput
							competency={props.competency}
							name="competencyLevelInput"
							party={graphql.EvaluationSubmissionParty.Manager}
						/>
					</Box>
					<Flex mt={4} justifyContent="flex-end">
						<Box mr={2}>
							<Button
								type="secondary"
								title={t('goals.create.form.competency.modal.cancelButton.title')}
								onClick={props.onCancel}
							/>
						</Box>
						<Button
							title={t('goals.create.form.competency.modal.addButton.title')}
							onClick={props.onSave}
						/>
					</Flex>
				</Modal.Contents>
			</Modal>
		</Popover>
	);
}
